import { getExtensionId } from '../../background/services'
import { WebcamSetting } from '../../types'
import { enableDragControl } from './enableDragControl'
import {
    getFromExtLocalStorage,
    getResourceURL,
} from '../../services/extServices'
import {
    PREFFERRED_WEBCAM_SETTING,
    WEBCAM_PROPS,
    WEBCAM_SETTING,
} from '../../background/constants'

const classes = {
    mini: 'Guidde_WebcamContainer-Mini',
    maxi: 'Guidde_WebcamContainer-Maxi',
}

export const startWebcam = () => {
    getFromExtLocalStorage([WEBCAM_SETTING], result => {
        const webcamSetting: WebcamSetting = result?.[WEBCAM_SETTING]

        if (webcamSetting === 'mini' || webcamSetting === 'maxi') {
            const container = document.querySelector('body')
            const existingCam = document.getElementById('GUIDDE-JS-Webcam')

            if (!container || existingCam) return

            getExtensionId(extensionId => {
                const webcamContainer = document.createElement('div')
                webcamContainer.id = 'GUIDDE-JS-Webcam'
                webcamContainer.className = 'Guidde_WebcamContainer'
                webcamContainer.classList.add(classes[webcamSetting])

                if (webcamSetting === 'mini') {
                    enableDragControl(webcamContainer, undefined, WEBCAM_PROPS)
                }

                const frame = document.createElement('iframe')
                frame.allow = `camera chrome-extension://${extensionId}`

                getFromExtLocalStorage([PREFFERRED_WEBCAM_SETTING], r => {
                    const chosenWebcam = r?.[PREFFERRED_WEBCAM_SETTING]

                    frame.src = `${getResourceURL(
                        '/webcam.html'
                    )}?mode=webcam&deviceId=${chosenWebcam}`

                    webcamContainer.appendChild(frame)

                    const existingWebcam =
                        document.getElementById('GUIDDE-JS-Webcam')
                    if (!existingWebcam) {
                        container.appendChild(webcamContainer)
                    }
                })
            }, {})
        }
    })
}
export const deleteWebcam = () => {
    const webcam = document.getElementById('GUIDDE-JS-Webcam')

    if (webcam) {
        webcam.remove()
    }
}
